import { render, staticRenderFns } from "./LogoLoading.vue?vue&type=template&id=116fe8ec&scoped=true"
var script = {}
import style0 from "./LogoLoading.vue?vue&type=style&index=0&id=116fe8ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116fe8ec",
  null
  
)

export default component.exports